import React, { useMemo } from 'react';
import { Chartjs, LoadingSpinner } from '../../../../components';
import { getChartTitle, getChartConfig } from './utils';
import i18n from '../../../../i18n';

export default function RangeChart({ state }) {
	if (!state?.measureData) {
		return <LoadingSpinner />;
	}

	const subject = state.selectedSubject;
	const selectedLocation = state.selectedLocation;

	const formattedRangeTextTitle = useMemo(
		() => getChartTitle(state, subject, selectedLocation),
		[state.setUrlQueryParam, i18n.language],
	);

	const rangeConfig = useMemo(
		() => getChartConfig(state, formattedRangeTextTitle),
		[state.setUrlQueryParam, i18n.language],
	);

	const chartSize = useMemo(
		() => ({
			height: '432px',
		}),
		[state.setUrlQueryParam],
	);

	return <Chartjs chartConfig={rangeConfig} chartId="rangeChart" chartSize={chartSize} />;
}
